import React from 'react';

import ChevronRightSimple from '@/components/svg/ChevronRight';
import VolumeUserIcon from '@/components/svg/VolumeUserIcon';
import cn from '@/helpers/utils/classNames';
import { roundToTwoDecimalPlaces } from '@/helpers/utils/numberHelpers';

interface VolumnCardProps {
  label: string;
  count: number;
  onClick: () => void;
  className?: string;
  iconColor?: string;
}
const VolumnCard = ({ label, count, onClick, className, iconColor = '#EFC6B6' }: VolumnCardProps) => {
  return (
    <div
      className={cn(
        'v2-flex v2-flex-col v2-gap-3 v2-p-8 md:v2-p-8 sm:v2-p-4 xs:v2-p-8 v2-bg-[#EFC6B6] v2-w-full v2-rounded-xs',
        className
      )}
    >
      <div className="v2-h-[40px] v2-w-[40px] v2-rounded-full v2-flex v2-items-center v2-justify-center v2-bg-white">
        <VolumeUserIcon fill={iconColor} />
      </div>

      <p className="v2-text-2xl v2-font-medium v2-font-sweet-sans-pro-medium v2-text-white v2-leading-[33px]">
        {label === 'Sponsoring' ? count : roundToTwoDecimalPlaces(count)}
      </p>
      <p className="v2-text-base v2-font-normal v2-font-sweet-sans-pro v2-text-white v2-leading-[22px]">{label}</p>
      <p
        className="v2-text-sm v2-font-normal v2-font-sweet-sans-pro v2-text-white v2-flex v2-items-center v2-gap-[2px] v2-h-[19px]"
        role="button"
        onClick={onClick}
      >
        Details
        <ChevronRightSimple stroke="white" className="md:v2-h-5 v2-h-[10px]" />
      </p>
    </div>
  );
};

export default VolumnCard;
